










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import {
  DigitalCurrencyAccountNotification,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_FAILURE
} from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-7-account-notification/account-notification-1'

@Component({
  components: {}
})
class DigitalCurrency19AccountNotificationIndicator extends Vue {
  @Prop({ default: () => new DigitalCurrencyAccountNotification() }) notificationItem?: DigitalCurrencyAccountNotification

  NOTIFICATION_TYPE_SUCCESS = NOTIFICATION_TYPE_SUCCESS
  NOTIFICATION_TYPE_WARNING = NOTIFICATION_TYPE_WARNING
  NOTIFICATION_TYPE_FAILURE = NOTIFICATION_TYPE_FAILURE
}

export default DigitalCurrency19AccountNotificationIndicator

